<script>
import { UICalendarIcon, UIListIcon } from "../icons"

const CALENDAR_VIEW = 'calendar';
const LIST_VIEW = 'list';
const DEFAULT_VIEW = LIST_VIEW;

export default {
  name: 'view-buttons',
  props: {
    view: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      buttons: [
        { icon: 'ui-list-icon', title: 'Список', name: LIST_VIEW },
        { icon: 'ui-calendar-icon', title: 'Календарь', name: CALENDAR_VIEW }
      ],
    }
  },
  components: {
    // icons
    'ui-calendar-icon': UICalendarIcon,
    'ui-list-icon': UIListIcon,
  },
  methods: {
    handleChangeViewClick (view) {
      this.$emit("update:view", view)
    }
  }
}
</script>

<template>
  <div class="t-events-buttons">
    <button
      v-for="button of buttons"
      class="t-events-buttons__item"
      :class="{
        _active: view === button.name
      }"
      @click="() => handleChangeViewClick(button.name)"
    >
      <component :is="button.icon"/>
      <div class="t-events-buttons__text">{{ button.title }}</div>
    </button>

  </div>  
</template>


// WEBPACK FOOTER //
// src/templates/pages/events/components/view-buttons/view-buttons.vue